import {
  MODAL_UPLOAD_FLOW_STORAGE_KEY,
  ModalFlow
} from "../../../../shared/components/ModalFlow/ModalFlow";
import { useWSModalCustom } from "@wingspanhq/fe-component-library";
import { useEffect, useMemo } from "react";
import { useLocationStateStorage } from "../../../../shared/hooks/useLocationStateStorage";
import { ModalFlowState } from "../../../../shared/components/ModalFlow/types";
import { FlowUploadDocumentProps } from "./types";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { Success } from "./Success";
import { useModalConfirmExit } from "./useModalConfirmExit";

const initialState: ModalFlowState<FlowUploadDocumentProps> = {
  state: {}
};

type FlowUploadDocumentComponentProps = {
  onClose: () => void;
  onSuccess?: () => void;
};

export const FlowUploadDocument: React.FC<FlowUploadDocumentComponentProps> = ({
  onClose,
  onSuccess
}) => {
  const confirmExitModal = useModalConfirmExit();

  return (
    <ModalFlow<FlowUploadDocumentProps>
      historyState={MODAL_UPLOAD_FLOW_STORAGE_KEY}
      initialState={initialState}
      confirmExitModal={confirmExitModal}
      title="Insurance document upload"
      sideSteps={[
        {
          key: "success",
          title: "Success",
          component: Success
        }
      ]}
      steps={[
        {
          key: "InsuranceDocumentUpload",
          title: "Insurance document upload",
          status: undefined,
          steps: [
            {
              key: "intro",
              title: "Intro",
              component: Step1,
              status: undefined
            },
            {
              key: "uploading",
              title: "Upload document",
              component: Step2,
              status: undefined,
              confirmExit: true
            },
            {
              key: "importing",
              title: "Complete import",
              component: Step3,
              status: undefined,
              confirmExit: true
            }
          ]
        }
      ]}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
};

type UseFlowUploadDocumentProps = {
  onSuccess: () => void;
};

export const useFlowUploadDocument = (props: UseFlowUploadDocumentProps) => {
  const [modalState] = useLocationStateStorage<
    ModalFlowState<FlowUploadDocumentProps>
  >(MODAL_UPLOAD_FLOW_STORAGE_KEY, initialState);

  const Component = useMemo(() => {
    return (componentProps: FlowUploadDocumentComponentProps) => (
      <FlowUploadDocument onSuccess={props.onSuccess} {...componentProps} />
    );
  }, []);

  const modal = useWSModalCustom(Component);
  const isModalStateExist = modalState.flow?.stepKey !== undefined;

  useEffect(() => {
    if (isModalStateExist) modal.open();
  }, [isModalStateExist]);

  return modal;
};
